module.exports = __webpack_public_path__ + "static/img/rczp-ban.c86c328.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rczp-ban.jpg
// module id = 2P3K
// module chunks = 1